/**
 * Référence statique des 277 POS de l'opération QR Code.
 * Extrait depuis Liste_POS_pour_operation_test.xlsx
 * Utilisé par QrDashboard.vue pour enrichir les données de l'API avec
 * la wilaya, le tier et l'offre de chaque POS via son salepoint_code.
 */

export const POS_REFERENCE = [

  {
    "code": "12345",
    "tier": "TIER 1",
    "wilaya": "Alger",
    "offre": "OFFRE 1",
    "potentiel": 20
  },
  {
    "code": "123456",
    "tier": "TIER 1",
    "wilaya": "Alger",
    "offre": "OFFRE 2",
    "potentiel": 20
  },
  {
    "code": "1234567",
    "tier": "TIER 1",
    "wilaya": "Alger",
    "offre": "OFFRE 3",
    "potentiel": 20
  },
  {
    "code": "16020063",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 140
  },
  {
    "code": "16020085",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 100
  },
  {
    "code": "16030004",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 200
  },
  {
    "code": "16050005",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "16050035",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 60
  },
  {
    "code": "16050057",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "16100032",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "16100055",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 200
  },
  {
    "code": "16120002",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "16120013",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "16120055",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "16120064",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 60
  },
  {
    "code": "16120084",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "16130046-U",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "16140017",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 60
  },
  {
    "code": "16140037",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 60
  },
  {
    "code": "16140053",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 80
  },
  {
    "code": "16140078",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 80
  },
  {
    "code": "16170009",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "16170104",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 60
  },
  {
    "code": "16170113",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 100
  },
  {
    "code": "16180035",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "16200033",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 140
  },
  {
    "code": "16210040",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 100
  },
  {
    "code": "16260016",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "16260049",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 60
  },
  {
    "code": "16260060",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 20
  },
  {
    "code": "16260061",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 20
  },
  {
    "code": "16260062",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 60
  },
  {
    "code": "16270014",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "16290005-U",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 20
  },
  {
    "code": "16290007-U",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "16290009",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 20
  },
  {
    "code": "16300010-U",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 20
  },
  {
    "code": "16300066",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 20
  },
  {
    "code": "16300068",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 20
  },
  {
    "code": "16300102",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 20
  },
  {
    "code": "16310005",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 20
  },
  {
    "code": "16310006",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 20
  },
  {
    "code": "16310007",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 20
  },
  {
    "code": "16310010",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "16310011",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 20
  },
  {
    "code": "16310014",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "16310016",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 20
  },
  {
    "code": "16310018",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 20
  },
  {
    "code": "16320021",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 1",
    "potentiel": 20
  },
  {
    "code": "16220006",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 100
  },
  {
    "code": "16220026",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 160
  },
  {
    "code": "16280024",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 100
  },
  {
    "code": "16290034",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 200
  },
  {
    "code": "16320004",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 300
  },
  {
    "code": "16320029",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 500
  },
  {
    "code": "16320043",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 20
  },
  {
    "code": "16330001-U",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 20
  },
  {
    "code": "16330005-U",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 20
  },
  {
    "code": "16330007-U",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 20
  },
  {
    "code": "16330008-U",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 20
  },
  {
    "code": "16330010",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 100
  },
  {
    "code": "16330013",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 200
  },
  {
    "code": "16330015",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 100
  },
  {
    "code": "16340008",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 100
  },
  {
    "code": "16340039",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "16350008",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 60
  },
  {
    "code": "16370002",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 60
  },
  {
    "code": "16390009",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 60
  },
  {
    "code": "16410026",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "16420020",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 140
  },
  {
    "code": "16440003-U",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "16440004-U",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "16440006",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "16440009-U",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "16440031",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "16440037",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "16440039",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "16440050",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "16440056",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "16440062",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "16440095",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 60
  },
  {
    "code": "16440098",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "16440109",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "16440115",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "16440119",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "16450001",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 60
  },
  {
    "code": "16450005",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "16450035",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "16450036",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "16450039",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "16450045",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "16450066",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 20
  },
  {
    "code": "16460007",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "16470001",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 20
  },
  {
    "code": "16490020",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 2",
    "potentiel": 20
  },
  {
    "code": "16340011",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 80
  },
  {
    "code": "16450054",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 60
  },
  {
    "code": "16460006",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 180
  },
  {
    "code": "16460023",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 80
  },
  {
    "code": "16470002",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 120
  },
  {
    "code": "16470007",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 300
  },
  {
    "code": "16490018",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 60
  },
  {
    "code": "16500002",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "16500008",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "16500012",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 100
  },
  {
    "code": "16500015",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 20
  },
  {
    "code": "16500018",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 60
  },
  {
    "code": "16500042",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "16500047",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 20
  },
  {
    "code": "16500048",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "16500057",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "16500060",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "16500066",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 20
  },
  {
    "code": "16500074",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "16500077",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 20
  },
  {
    "code": "16500086",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "16500102",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "16500112",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 20
  },
  {
    "code": "16500113",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 60
  },
  {
    "code": "16500114",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "16500115",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "16500118",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 20
  },
  {
    "code": "16510008",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "16510012",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "16510034",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 20
  },
  {
    "code": "16520019",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 20
  },
  {
    "code": "16520057",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 20
  },
  {
    "code": "16530024",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "16530041",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 20
  },
  {
    "code": "16540002",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 60
  },
  {
    "code": "16540023",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "16540038",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 60
  },
  {
    "code": "16540050",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 600
  },
  {
    "code": "16540053",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 600
  },
  {
    "code": "16540056",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 20
  },
  {
    "code": "16550033",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 20
  },
  {
    "code": "16560010",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 20
  },
  {
    "code": "16560022",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 120
  },
  {
    "code": "16570001",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 20
  },
  {
    "code": "16570006",
    "tier": "TIER 1",
    "wilaya": "ALGER",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "25010001-U",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "25010007",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 1",
    "potentiel": 400
  },
  {
    "code": "25010044",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 1",
    "potentiel": 600
  },
  {
    "code": "25010045",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 1",
    "potentiel": 400
  },
  {
    "code": "25010094-U",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 1",
    "potentiel": 60
  },
  {
    "code": "25010108-U",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "25010308",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "25040004",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "25060023-U",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 1",
    "potentiel": 60
  },
  {
    "code": "25060042-U",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "25060047-U",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "25060061-U",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 1",
    "potentiel": 60
  },
  {
    "code": "25060067-U",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "25100055",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 1",
    "potentiel": 300
  },
  {
    "code": "25010051-U",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 2",
    "potentiel": 400
  },
  {
    "code": "25010172",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 2",
    "potentiel": 600
  },
  {
    "code": "25010198",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 2",
    "potentiel": 600
  },
  {
    "code": "25010302",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 2",
    "potentiel": 1000
  },
  {
    "code": "25060105-U",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 2",
    "potentiel": 60
  },
  {
    "code": "25060129-U",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 2",
    "potentiel": 60
  },
  {
    "code": "25060293",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 2",
    "potentiel": 80
  },
  {
    "code": "25060453",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "25060503",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "25060523",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "25060545",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "25060586",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 2",
    "potentiel": 60
  },
  {
    "code": "25060590",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "25060612",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 2",
    "potentiel": 200
  },
  {
    "code": "25010370",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 3",
    "potentiel": 800
  },
  {
    "code": "25010460",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 3",
    "potentiel": 1000
  },
  {
    "code": "25010491",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 3",
    "potentiel": 500
  },
  {
    "code": "25050010",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 3",
    "potentiel": 2000
  },
  {
    "code": "25060617",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 3",
    "potentiel": 60
  },
  {
    "code": "25060618",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "25060624",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "25060628",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 3",
    "potentiel": 1000
  },
  {
    "code": "25060658",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "25060667",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "25100069",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 3",
    "potentiel": 60
  },
  {
    "code": "25100078",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 3",
    "potentiel": 60
  },
  {
    "code": "25100080",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "25100087",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 3",
    "potentiel": 80
  },
  {
    "code": "25100100",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "25100105",
    "tier": "TIER 1",
    "wilaya": "CONSTANTINE",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "31020007",
    "tier": "TIER 1",
    "wilaya": "ORAN",
    "offre": "OFFRE 1",
    "potentiel": 4000
  },
  {
    "code": "31030095",
    "tier": "TIER 1",
    "wilaya": "ORAN",
    "offre": "OFFRE 1",
    "potentiel": 8000
  },
  {
    "code": "31030321",
    "tier": "TIER 1",
    "wilaya": "ORAN",
    "offre": "OFFRE 1",
    "potentiel": 2000
  },
  {
    "code": "31030322",
    "tier": "TIER 1",
    "wilaya": "ORAN",
    "offre": "OFFRE 1",
    "potentiel": 2800
  },
  {
    "code": "31030324",
    "tier": "TIER 1",
    "wilaya": "ORAN",
    "offre": "OFFRE 1",
    "potentiel": 1000
  },
  {
    "code": "31030325",
    "tier": "TIER 1",
    "wilaya": "ORAN",
    "offre": "OFFRE 2",
    "potentiel": 2100
  },
  {
    "code": "31060002",
    "tier": "TIER 1",
    "wilaya": "ORAN",
    "offre": "OFFRE 2",
    "potentiel": 3000
  },
  {
    "code": "31060005",
    "tier": "TIER 1",
    "wilaya": "ORAN",
    "offre": "OFFRE 2",
    "potentiel": 4000
  },
  {
    "code": "31060040",
    "tier": "TIER 1",
    "wilaya": "ORAN",
    "offre": "OFFRE 2",
    "potentiel": 3000
  },
  {
    "code": "31030034-U",
    "tier": "TIER 1",
    "wilaya": "ORAN",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "31130012-U",
    "tier": "TIER 1",
    "wilaya": "ORAN",
    "offre": "OFFRE 3",
    "potentiel": 2000
  },
  {
    "code": "31130044",
    "tier": "TIER 1",
    "wilaya": "ORAN",
    "offre": "OFFRE 3",
    "potentiel": 5000
  },
  {
    "code": "23010010",
    "tier": "TIER 2",
    "wilaya": "ANNABA",
    "offre": "OFFRE 1",
    "potentiel": 60
  },
  {
    "code": "23010027-U",
    "tier": "TIER 2",
    "wilaya": "ANNABA",
    "offre": "OFFRE 1",
    "potentiel": 20
  },
  {
    "code": "23010052-U",
    "tier": "TIER 2",
    "wilaya": "ANNABA",
    "offre": "OFFRE 1",
    "potentiel": 20
  },
  {
    "code": "23010056",
    "tier": "TIER 2",
    "wilaya": "ANNABA",
    "offre": "OFFRE 1",
    "potentiel": 20
  },
  {
    "code": "23010084",
    "tier": "TIER 2",
    "wilaya": "ANNABA",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "23010271",
    "tier": "TIER 2",
    "wilaya": "ANNABA",
    "offre": "OFFRE 1",
    "potentiel": 60
  },
  {
    "code": "23050019-U",
    "tier": "TIER 2",
    "wilaya": "ANNABA",
    "offre": "OFFRE 1",
    "potentiel": 300
  },
  {
    "code": "23010109",
    "tier": "TIER 2",
    "wilaya": "ANNABA",
    "offre": "OFFRE 2",
    "potentiel": 20
  },
  {
    "code": "23010338",
    "tier": "TIER 2",
    "wilaya": "ANNABA",
    "offre": "OFFRE 2",
    "potentiel": 400
  },
  {
    "code": "23050005-U",
    "tier": "TIER 2",
    "wilaya": "ANNABA",
    "offre": "OFFRE 2",
    "potentiel": 20
  },
  {
    "code": "23050012-U",
    "tier": "TIER 2",
    "wilaya": "ANNABA",
    "offre": "OFFRE 2",
    "potentiel": 20
  },
  {
    "code": "23050014-U",
    "tier": "TIER 2",
    "wilaya": "ANNABA",
    "offre": "OFFRE 2",
    "potentiel": 20
  },
  {
    "code": "23050026-U",
    "tier": "TIER 2",
    "wilaya": "ANNABA",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "23110003",
    "tier": "TIER 2",
    "wilaya": "ANNABA",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "23030008",
    "tier": "TIER 2",
    "wilaya": "ANNABA",
    "offre": "OFFRE 3",
    "potentiel": 500
  },
  {
    "code": "23050025-U",
    "tier": "TIER 2",
    "wilaya": "ANNABA",
    "offre": "OFFRE 3",
    "potentiel": 20
  },
  {
    "code": "23050046",
    "tier": "TIER 2",
    "wilaya": "ANNABA",
    "offre": "OFFRE 3",
    "potentiel": 20
  },
  {
    "code": "23110012-U",
    "tier": "TIER 2",
    "wilaya": "ANNABA",
    "offre": "OFFRE 3",
    "potentiel": 20
  },
  {
    "code": "23110021-U",
    "tier": "TIER 2",
    "wilaya": "ANNABA",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "22010012",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 1",
    "potentiel": 140
  },
  {
    "code": "22010046-U",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "22010048",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 1",
    "potentiel": 160
  },
  {
    "code": "22010052",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 1",
    "potentiel": 140
  },
  {
    "code": "22010073",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "22010079",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 1",
    "potentiel": 300
  },
  {
    "code": "22010082",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 1",
    "potentiel": 120
  },
  {
    "code": "22010085-U",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "22010120",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 1",
    "potentiel": 140
  },
  {
    "code": "22010427",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 1",
    "potentiel": 80
  },
  {
    "code": "22280003-U",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 1",
    "potentiel": 100
  },
  {
    "code": "22010154",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 2",
    "potentiel": 140
  },
  {
    "code": "22010187",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 2",
    "potentiel": 140
  },
  {
    "code": "22010360",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 2",
    "potentiel": 200
  },
  {
    "code": "22010364",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 2",
    "potentiel": 140
  },
  {
    "code": "22010393",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 2",
    "potentiel": 160
  },
  {
    "code": "22010415",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 2",
    "potentiel": 140
  },
  {
    "code": "22010436",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 2",
    "potentiel": 600
  },
  {
    "code": "22010464",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "22010478",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "22010485",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "22280010",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "22450004",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 2",
    "potentiel": 200
  },
  {
    "code": "22010488",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "22010490",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "22010492",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "22030009",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 3",
    "potentiel": 300
  },
  {
    "code": "22050001",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 3",
    "potentiel": 200
  },
  {
    "code": "22140002",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 3",
    "potentiel": 200
  },
  {
    "code": "22140016",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 3",
    "potentiel": 140
  },
  {
    "code": "22280001-U",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 3",
    "potentiel": 160
  },
  {
    "code": "22280002-U",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 3",
    "potentiel": 200
  },
  {
    "code": "22280020",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 3",
    "potentiel": 140
  },
  {
    "code": "22290026",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 3",
    "potentiel": 560
  },
  {
    "code": "22450016",
    "tier": "TIER 2",
    "wilaya": "SIDI BEL ABBES",
    "offre": "OFFRE 3",
    "potentiel": 100
  },
  {
    "code": "46010001",
    "tier": "TIER 3",
    "wilaya": "AIN-TEMOUCHENT",
    "offre": "OFFRE 1",
    "potentiel": 20
  },
  {
    "code": "46010009-U",
    "tier": "TIER 3",
    "wilaya": "AIN-TEMOUCHENT",
    "offre": "OFFRE 1",
    "potentiel": 200
  },
  {
    "code": "46010061",
    "tier": "TIER 3",
    "wilaya": "AIN-TEMOUCHENT",
    "offre": "OFFRE 1",
    "potentiel": 60
  },
  {
    "code": "46040018",
    "tier": "TIER 3",
    "wilaya": "AIN-TEMOUCHENT",
    "offre": "OFFRE 1",
    "potentiel": 60
  },
  {
    "code": "46090002-U",
    "tier": "TIER 3",
    "wilaya": "AIN-TEMOUCHENT",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "46010064",
    "tier": "TIER 3",
    "wilaya": "AIN-TEMOUCHENT",
    "offre": "OFFRE 2",
    "potentiel": 200
  },
  {
    "code": "46040004",
    "tier": "TIER 3",
    "wilaya": "AIN-TEMOUCHENT",
    "offre": "OFFRE 2",
    "potentiel": 600
  },
  {
    "code": "46140026",
    "tier": "TIER 3",
    "wilaya": "AIN-TEMOUCHENT",
    "offre": "OFFRE 2",
    "potentiel": 60
  },
  {
    "code": "46140029",
    "tier": "TIER 3",
    "wilaya": "AIN-TEMOUCHENT",
    "offre": "OFFRE 2",
    "potentiel": 340
  },
  {
    "code": "46140041",
    "tier": "TIER 3",
    "wilaya": "AIN-TEMOUCHENT",
    "offre": "OFFRE 2",
    "potentiel": 60
  },
  {
    "code": "46190004-U",
    "tier": "TIER 3",
    "wilaya": "AIN-TEMOUCHENT",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "46200018",
    "tier": "TIER 3",
    "wilaya": "AIN-TEMOUCHENT",
    "offre": "OFFRE 3",
    "potentiel": 100
  },
  {
    "code": "46190005",
    "tier": "TIER 3",
    "wilaya": "AIN-TEMOUCHENT",
    "offre": "OFFRE 3",
    "potentiel": 500
  },
  {
    "code": "46190031",
    "tier": "TIER 3",
    "wilaya": "AIN-TEMOUCHENT",
    "offre": "OFFRE 3",
    "potentiel": 60
  },
  {
    "code": "46190037",
    "tier": "TIER 3",
    "wilaya": "AIN-TEMOUCHENT",
    "offre": "OFFRE 3",
    "potentiel": 300
  },
  {
    "code": "46190053",
    "tier": "TIER 3",
    "wilaya": "AIN-TEMOUCHENT",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "46200016",
    "tier": "TIER 3",
    "wilaya": "AIN-TEMOUCHENT",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "46230016-U",
    "tier": "TIER 3",
    "wilaya": "AIN-TEMOUCHENT",
    "offre": "OFFRE 3",
    "potentiel": 400
  },
  {
    "code": "15010041",
    "tier": "TIER 3",
    "wilaya": "TIZI OUZOU",
    "offre": "OFFRE 1",
    "potentiel": 20
  },
  {
    "code": "15010053",
    "tier": "TIER 3",
    "wilaya": "TIZI OUZOU",
    "offre": "OFFRE 1",
    "potentiel": 20
  },
  {
    "code": "15010058",
    "tier": "TIER 3",
    "wilaya": "TIZI OUZOU",
    "offre": "OFFRE 1",
    "potentiel": 20
  },
  {
    "code": "15010160",
    "tier": "TIER 3",
    "wilaya": "TIZI OUZOU",
    "offre": "OFFRE 1",
    "potentiel": 40
  },
  {
    "code": "15200012",
    "tier": "TIER 3",
    "wilaya": "TIZI OUZOU",
    "offre": "OFFRE 2",
    "potentiel": 20
  },
  {
    "code": "15210003",
    "tier": "TIER 3",
    "wilaya": "TIZI OUZOU",
    "offre": "OFFRE 2",
    "potentiel": 40
  },
  {
    "code": "15290014",
    "tier": "TIER 3",
    "wilaya": "TIZI OUZOU",
    "offre": "OFFRE 2",
    "potentiel": 20
  },
  {
    "code": "15340011",
    "tier": "TIER 3",
    "wilaya": "TIZI OUZOU",
    "offre": "OFFRE 2",
    "potentiel": 20
  },
  {
    "code": "15160004",
    "tier": "TIER 3",
    "wilaya": "TIZI OUZOU",
    "offre": "OFFRE 3",
    "potentiel": 60
  },
  {
    "code": "15370013",
    "tier": "TIER 3",
    "wilaya": "TIZI OUZOU",
    "offre": "OFFRE 3",
    "potentiel": 20
  },
  {
    "code": "15380002",
    "tier": "TIER 3",
    "wilaya": "TIZI OUZOU",
    "offre": "OFFRE 3",
    "potentiel": 40
  },
  {
    "code": "15380010",
    "tier": "TIER 3",
    "wilaya": "TIZI OUZOU",
    "offre": "OFFRE 3",
    "potentiel": 20
  },

]

// Lookup table pour recherche O(1) par code
export const POS_BY_CODE = POS_REFERENCE.reduce((acc, p) => {
  acc[p.code] = p
  return acc
}, {})

// Agrégats pré-calculés
export const WILAYAS = [...new Set(POS_REFERENCE.map(p => p.wilaya))].sort()
export const TIERS = ['TIER 1', 'TIER 2', 'TIER 3']
export const OFFRES = ['OFFRE 1', 'OFFRE 2', 'OFFRE 3']

// Potentiel total par dimension (utile pour calculer les taux de réalisation)
export const POTENTIEL_TOTAL = POS_REFERENCE.reduce((s, p) => s + p.potentiel, 0)

export const POTENTIEL_BY_WILAYA = POS_REFERENCE.reduce((acc, p) => {
  acc[p.wilaya] = (acc[p.wilaya] || 0) + p.potentiel
  return acc
}, {})

export const POTENTIEL_BY_TIER = POS_REFERENCE.reduce((acc, p) => {
  acc[p.tier] = (acc[p.tier] || 0) + p.potentiel
  return acc
}, {})

export const POTENTIEL_BY_OFFRE = POS_REFERENCE.reduce((acc, p) => {
  acc[p.offre] = (acc[p.offre] || 0) + p.potentiel
  return acc
}, {})

export default POS_REFERENCE
